module.exports = __webpack_public_path__ + "static/user-list-column-do-ef9f76d3aac7c9027379dd280ad43a3e.png";